export const TAGS = [
    'short',
    'feature',
    'script',
    'commercial',
    'skit',
    'act',
    'reels',
    'pitch',
    'poster',
    'picture',
    'advertisement',
    'monologue',
    'podcast',
    'dance',
    'news',
    'travel',
    'pitch',
    'poetry',
    'health',
];
export const PROJECT_CATEGORY = [
    'podcast',
    'music video',
    'dance',
    'fashion',
    'lifestyle',
    'travel',
    'education',
    'health',
    'news',
    'short',
    'feature',
    'script',
    'commercial',
    'skit',
    'act',
    'reels',
    'pitch',
    'poster',
    'picture',
    'advertisement',
    'monologue',
    'poetry',
    'beauty',
    'rap',
];
export const EMAIL_TYPE = [
    { id: 0, title: 'contest submission notification email' },
    { id: 1, title: 'contest notification email' },
    { id: 3, title: 'voting reminder email' },
    { id: 4, title: 'send contest open email' },
];
